export const config = {
	isDev: process.env.NODE_ENV !== 'production',
	// isDev: false,
	apiUrl:
		process.env.NODE_ENV === 'production'
			? 'https://api.100syyta.fi/api/v2'
			: process.env.NODE_ENV === 'development'
			? 'http://suoma-tem-api.atk7.dqcomms.com:81/api/v2'
			: 'https://api.100syyta.fi/api/v2',

	mapsApiKey: 'AIzaSyBZ_r6abs3a5c8_WH26ryAc0Iu8qdapUA0',
	siteUrl:
		process.env.NODE_ENV === 'production'
			? // ? 'https://100syyta.fi'
			  'https://100syyta.fi'
			: 'https://100syyta.fi',
	appUrl:
		process.env.NODE_ENV === 'production'
			? 'https://yrityksille.100syyta.fi'
			: 'localhost:3000',

	maxFileSize: 10 * 1024 * 1024,
};
